import { useState, useEffect } from 'react';
import api from '../../services/api';import "../../assets/styles/Intern/PoliciesSection.css";

function PoliciesSection() {
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getPolicies()
      .then((d) => {
        setPolicies((d || []).filter((p) => String(p?.status || '').toLowerCase() === 'active'));
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const handleDownload = async (p) => {
    try {
      const res = await api.downloadPolicy(p.id);
      if (res?.url) await api.downloadFile(res.url, res.name || p.name || p.title || 'policy'); else
      {
        const blob = new Blob([`${p.title}\n${'='.repeat(40)}\n\nCategory: ${p.category || 'General'}\n\n${p.summary || 'No content'}`], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = (res?.name || p.name || p.title || 'policy') + '.txt';
        a.click();
        URL.revokeObjectURL(url);
      }
    } catch {alert('Download not available');}
  };

  return (
    <div>
      {loading ? <div className="policiessection-inline-1">Loading policies...</div> :
      policies.length === 0 ? <div className="policiessection-inline-2">No policies available yet</div> :
      <div className="policiessection-inline-3">
        {policies.map((p) =>
        <div key={p.id} className="card policiessection-inline-4">
            <div className="policiessection-inline-5">
              <div>
                <div className="policiessection-inline-6">{p.name || p.title}</div>
                <div className="policiessection-inline-7">{p.category || 'General'}</div>
                {p.summary && <div className="policiessection-inline-8">{p.summary}</div>}
              </div>
              <button className="btn btn-sm policiessection-inline-9" onClick={() => handleDownload(p)}>Download</button>
            </div>
          </div>
        )}
      </div>}
    </div>);

}

export default PoliciesSection;
